import { Typography, TypographyProps } from '@mui/material';
import { ElementType, forwardRef } from 'react';

export type ExtendedTypographyProps = TypographyProps & { component?: ElementType };

const TypographyWrapper = forwardRef<HTMLElement, ExtendedTypographyProps>((props, ref) => (
  <Typography ref={ref} {...props} />
));

export default TypographyWrapper;
